<template>
  <b-modal :id="componentId+'-modal-save'" ok-only ok-title="Close" title="Export Data / Plots / MetaData">

    <h3>Data</h3>
    <div class="form-group form-row mt-2 mb-2" style="font-size: 1vmin;">
      <div class="col-6 align-content-center">
        <vue-json-to-csv :json-data="formattedData" :csv-title="exportFileName">
          <b-button class="">CSV</b-button>
        </vue-json-to-csv>
      </div>
      <div class="col-6">
        <b-button v-on:click="exportDataAsJson">Json</b-button>
      </div>

    </div>
    <hr>
    <h3>Plots</h3>
    <div class="form-group form-row mt-2" style="font-size: 1.4vmin;">
      <div class="col-6 align-content-center">
        <b-button v-on:click="exportPlotAsPNG">PNG</b-button>
      </div>
      <div class="col-6 align-content-center">
        <b-button v-on:click="exportPlotAsSVG">SVG</b-button>
      </div>
    </div>
    <hr>
    <h3>Metadata <i class="bi bi-question-circle-fill" data-toogle="tooltip" title="Metadata includes the selected dataset description, the specific parameters applied to the plot and the plot legend."
                    v-bind:style="{ fontSize : '15px'}" v-b-tooltip.hover></i></h3>
    <div class="form-group mt-2" style="font-size: 1.4vmin;">
      <b-button v-on:click="exportPlotMetadata">Json</b-button>
    </div>

  </b-modal>

</template>

<script>
import {saveAs} from 'file-saver';
import {ApiCall} from "../mixins/ApiMixin";
import VueJsonToCsv from 'vue-json-to-csv'
import axios from "axios";
import * as svg from "save-svg-as-png";

export default {
  name: "ExportDialog",
  props: ['componentId', 'formattedData', 'plotData', 'exportFileName', 'dataset', 'legend'],
  mixins: [ApiCall],
  data() {
    return {}
  },
  components: {
    VueJsonToCsv
  },
  methods: {

    exportPlotMetadata() {
      let me = this
      me.apiCallsInProgress++
      axios
          .get(this.sanitizeApiCall(this.$store.state.apiRootPath,['metadata',this.dataset]))
          .then(function (response) {
            me.metadata = JSON.stringify(response.data)
            let title = document.getElementById(me.componentId + 'plot_title').innerText
            let txt = "Title : " + title + "\n" +
                "Initial selection : Dataset - " + me.dataset + ", Taxon - " + me.searchPanelTaxon + ", Rank - " + me.rank + ", Date-range - " + me.dateStart + " - " + me.dateEnd + "\n" +
                "Representation by : " + me.representation + "\n" +
                "User Selection :  Taxon - " + me.taxon + " or ASV - " + me.asv + ", Fraction - " + me.fraction + "\n" +
                "Metadata : " + me.metadata + "\n" +
                "Legend  : " + me.legend
            let blob_txt = new Blob([txt], {type: "text/plain;charset=utf-8"});
            saveAs(blob_txt, me.exportFileName + "_metadata.txt");
            me.apiCallsInProgress--
          })
    },
    exportDataAsJson() {
      let data = JSON.stringify(this.plotData)
      let blob_data = new Blob([data], {type: "text/plain;charset=utf-8"});
      saveAs(blob_data, this.exportFileName + "_data.txt", true);
    },
    buildCompleteSVGPlot() {
      let svgContainer = document.createElementNS('http://www.w3.org/2000/svg', "svg");
      console.debug("SVG Container: " + svgContainer);
      let parentElement = document.getElementById(this.componentId + "-plot_area");
      let svgs = parentElement.getElementsByTagName('svg');
      let marginX = 20;
      let marginY = 20;
      let xposition = marginX;
      let yposition = marginY;
      let svgdata = "";
      let totalwidth = xposition;
      let totalheight = yposition * 2;
      for (let i = 0; i < svgs.length; i++) {
        let currentSvg = svgs[i];
        svgdata += "<g transform=\"translate(" + xposition + "," + yposition + ")\">" + svgs[i].innerHTML + "</g>";
        let svgWidth = currentSvg.getBoundingClientRect().width;
        let svgHeight = currentSvg.getBoundingClientRect().height;
        if (totalwidth < xposition + (svgWidth + marginX) * 2) {
          totalwidth = xposition + (svgWidth + marginX) * 2;
        }
        if (totalheight < yposition + (svgHeight + marginY) * 2) {
          totalheight += yposition + (svgHeight + marginY) * 2;
        }
        if (i % 2 == 0) {
          xposition += (svgWidth + marginX) * 2;
        } else {
          xposition = marginX;
          yposition += (svgHeight + marginY) * 2;
        }
      }
      svgContainer.innerHTML = svgdata;
      svgContainer.setAttribute('width', totalwidth);
      svgContainer.setAttribute('height', totalheight);
      return svgContainer;
    },
    buildFileNameRoot() {
      let timestamp = new Date();
      let timestampString = timestamp.toLocaleDateString('en-GB').split('/').reverse().join('');
      timestampString += '-' + timestamp.toLocaleTimeString().replaceAll(":", "");
      return this.exportFileName + '-' + timestampString;
    },
    exportPlotAsSVG() {
      let svgContainer = this.buildCompleteSVGPlot();
      svgContainer.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      let fileNameRoot = this.buildFileNameRoot();
      let blob = new Blob([svgContainer.outerHTML], {type: "image/svg+xml;charset=utf-8"});
      saveAs(blob, fileNameRoot + ".svg", true);
    },
    exportPlotAsPNG() {
      let svgContainer = this.buildCompleteSVGPlot();
      let fileNameRoot = this.buildFileNameRoot();
      svg.saveSvgAsPng(svgContainer, fileNameRoot + ".png", {backgroundColor: 'white'});
    },
  }
}

</script>

<style scoped>

</style>
